import { render, staticRenderFns } from "./ColumnChart.vue?vue&type=template&id=c558288a&scoped=true&"
import script from "./ColumnChart.vue?vue&type=script&lang=js&"
export * from "./ColumnChart.vue?vue&type=script&lang=js&"
import style0 from "./ColumnChart.vue?vue&type=style&index=0&id=c558288a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c558288a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c558288a')) {
      api.createRecord('c558288a', component.options)
    } else {
      api.reload('c558288a', component.options)
    }
    module.hot.accept("./ColumnChart.vue?vue&type=template&id=c558288a&scoped=true&", function () {
      api.rerender('c558288a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/ColumnChart.vue"
export default component.exports